import React from 'react';
import './App.css';
import Game from './Components/Game';

function App() {
  return (
    <div className="App">
      <Game />
    </div>
  );
}

export default App;
